import toNumber from 'lodash/toNumber';

const Breakpoints = {
  sm: '490px',
  smp: '640px',
  md: '768px',
  lg: '935px',
  xl: '1280px',
  '2xl': '1536px',
};

type TOKEN = keyof typeof Breakpoints;

// This utility allows to get breakpoints measures with offset
// getBreakpointWithOffset('sm', -1) === '489px'
export const getBreakpointWithOffset = (
  token: TOKEN,
  offset: number,
): string => {
  const SUFFIX = 'px';
  const bp = Breakpoints[token];
  const n = toNumber(bp.replace(SUFFIX, '')) + offset;
  return `${n}${SUFFIX}`;
};

export default Breakpoints;
